// extracted by mini-css-extract-plugin
module.exports = {"root":"tkGKux7U","styledSpan":"MagoP6y7"};